/**
 * FE-M4 (audit, 17.09): decizia PURA din spatele efectului de cautare din
 * `SiiirSchoolSelector` -- CE trebuie trimis catre `updateFilter`, separat de CAND (debounce-ul,
 * care ramane in componenta, netestabil fara jsdom).
 *
 * `null` = nicio actualizare acum (sub 3 caractere, se asteapta mai mult text).
 * Golirea campului (`''`) intoarce cheile pe `undefined` explicit -- nu `{}`,
 * pentru ca `updateFilter` face spread peste filtrul anterior (`use-spring-page-query.ts:56-59`):
 * un `{}` nu sterge nimic, doar `undefined` pe cheia exacta o goleste.
 *
 * R2-10 (18.09): textul pleaca pe `cautare`, nu pe `numeInstitutieInvatamant`. Backendul sparge
 * `cautare` in cuvinte si le cauta pe toate, in denumire SI in localitate/judet, fara diacritice --
 * asa «scoala 23 constanta» gaseste scoala, ceea ce inainte intorcea zero.
 *
 * 🔴 **Cheia veche se goleste la FIECARE actualizare**, nu doar la golirea campului: `updateFilter`
 * face spread peste filtrul anterior, deci un `numeInstitutieInvatamant` ramas de dinainte s-ar
 * adauga la noua cautare ca un AND invizibil. Nu e teoretic -- exact asta face spread-ul.
 *
 * R2-10b (18.09): **un numar de 1-2 cifre se trimite**, desi e sub pragul de 3 caractere. Pragul
 * exista ca sa nu plece o cerere la fiecare litera tastata, dar „23" e un termen complet, nu un
 * inceput de cuvant -- si backendul potriveste numerele pe cuvant intreg. Fara exceptia asta,
 * cautarea dupa numarul scolii nu ajungea niciodata la server.
 */
export function filtruDeCautareScoala(
    searchQuery: string
): { cautare: string | undefined; numeInstitutieInvatamant: string | undefined } | null {
    if (searchQuery.length === 0) {
        return { cautare: undefined, numeInstitutieInvatamant: undefined };
    }
    if (searchQuery.length < 3 && !/^\d{1,2}$/.test(searchQuery.trim())) {
        return null;
    }
    return { cautare: searchQuery, numeInstitutieInvatamant: undefined };
}
